import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import { withRouter } from 'react-router-dom';
import icon from '../img/icon.png'
import '../css/App.css';



class Nav extends Component{

    

render() {


return(

<nav className="navbar navbar-expand-lg navbar-light bg-primary " >
<div class="container-fluid">
<div className="navbar-header pl-lg-10" >
<img width="50" src={icon} alt="logo" />
</div>
<button
className="navbar-toggler"
type="button"
data-toggle="collapse"
data-target="#navbarNavDropdown"
aria-controls="navbarNavDropdown"
aria-expanded="false"
aria-label="Toggle navigation"
>
<span className="navbar-toggler-icon" />
</button>
<div
className="collapse navbar-collapse navbar-right pr-5"
id="navbarNavDropdown"
>
<ul className="nav navbar-nav ml-auto">
<li className="nav-item">
<a href="#home">
<Link className="nav-link js-scroll-trigger text-dark b"  to='/'>
Inicio
</Link>
</a>
</li>


<li className="nav-item">
<a href="#about">

<Link className="nav-link js-scroll-trigger text-dark b" to='/about' >
Sobre mí
</Link>

</a>
</li>
<li className="nav-item">
<a href="#skills">
<Link className="nav-link js-scroll-trigger text-dark b" to='/skills'>
Habilidades
</Link>
</a>
</li>
<li className="nav-item">
<a href="#projects">
<Link className="nav-link js-scroll-trigger text-dark b" to='/projects'>
Proyectos
</Link>
</a>
</li>

</ul>

</div>
</div>
</nav>);

}
}

export default withRouter(Nav);